import React, { useState } from 'react';
import { Box, } from '@mui/material';

import CanvasApi from '../../../services/CanvasApi';
import ReplaceBackgroundModal from './ReplaceBackgroundModal';
import EditImageWithTextModal from './EditImageWithTextModal';
export const COMPONENT_STATE_DISPLAY_MODAL = 'showModal';

interface CanvasModalContainerProps {
  canvasApi: CanvasApi;
}

const CanvasModalContainer: React.FC<CanvasModalContainerProps> = ({ canvasApi }) => {

  const [showModal, setShowModal] = useState(false);

  canvasApi.registerComponentState(COMPONENT_STATE_DISPLAY_MODAL, showModal, setShowModal);

  return (

    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: '100%',
        zIndex: 50,
        opacity: 0.5,
        justifyContent: 'center',
        alignItems: 'center',
        display: (showModal ? 'flex' : 'none'),
      }}>
      <ReplaceBackgroundModal canvasApi={canvasApi} />
      <EditImageWithTextModal canvasApi={canvasApi} />

    </Box>
  );
};

export default CanvasModalContainer;